<template>
  <div class="floating-icon floating-icon-open" id="div_open" style="display: none">
    <button
      type="button"
      class="sidebar-toggle sidebar-toggle--open"
      aria-label="Mostrar menú lateral"
      title="Mostrar menú"
      @click.stop="open"
    >
      <svg
        class="sidebar-toggle__icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          stroke-width="2.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="sidebar-toggle__label">Menú</span>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    open() {
      const sidebar = document.getElementById('body__sidebar')
      if (sidebar) {
        sidebar.classList.remove('open')
      }

      const divOpen = document.getElementById('div_open')
      if (divOpen) divOpen.style.display = 'none'

      const divClose = document.getElementById('div_close')
      if (divClose) divClose.style.display = 'block'
    },
  },
}
</script>
